export default __webpack_public_path__ + "static/media/ap_guardian_button.0f844df1.png";